import { IPriceData } from 'Quotes/types/store';
import { Supplier } from 'Quotes/types/supplier';

export const isSelectedPriceOnNet = (selectedPrice: IPriceData, end: string) => {
  return end === 'aEndLocation'
    ? selectedPrice.a_end_access_type === Supplier.NONE || selectedPrice.a_end_access_type === Supplier.COLT
    : selectedPrice.b_end_access_type === Supplier.NONE || selectedPrice.b_end_access_type === Supplier.COLT;
};
